import { withApiData, ApiDataBinding } from 'react-api-data';
import { WithTranslation, withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import React, { FunctionComponent, useState } from 'react';
import Tooltip from 'components/utils/Tooltip';
import { ContractItem, ApiResponse, ReactApiDataActions } from 'constants/api';
import FormModal from './FormModal';
import { Alert } from 'reactstrap';

interface InProps {
    contract: ContractItem;
    exchange: string;
    organisationUuid?: string;
    onSuccess?: () => void;
}

interface EnhanceProps {
    archiveContract: ApiDataBinding<ApiResponse<ContractItem>>;
    apiDataActions: ReactApiDataActions;
}

type Props = EnhanceProps & InProps & WithTranslation;

const enhance = compose<Props, InProps>(
    withApiData({
        archiveContract: 'archiveContract',
    }),
    withTranslation()
);

const ContractArchiveModal: FunctionComponent<Props> = ({
    archiveContract,
    exchange,
    contract,
    organisationUuid,
    apiDataActions,
    t,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    function toggle() {
        setIsOpen((isOpen) => !isOpen);
    }

    function onSubmit() {
        return archiveContract.perform({
            exchange: exchange.toUpperCase(),
            contractId: contract.uuid,
        });
    }

    function onSuccess() {
        if (organisationUuid) {
            apiDataActions.invalidateCache('getOrganisationContracts', {
                organisationUuid,
                all_contracts: 'true',
            });
        }
    }
    return (
        <React.Fragment>
            <FormModal
                header={t('archiveContractModal.headerTitle')}
                isOpen={isOpen}
                toggle={toggle}
                initialValues={{}}
                onSubmit={onSubmit}
                onSuccess={onSuccess}
                successMessage={t('notification.archiveContractSuccessful')}
            >
                {() => (
                    <React.Fragment>
                        <Alert color="warning" className="mb-0">
                            <strong>{t('common.warning')}</strong>
                            <p>{t('archiveContractModal.warningMessage')}</p>
                        </Alert>
                    </React.Fragment>
                )}
            </FormModal>

            {!contract.is_active && <i className="fas fa-trash mt-1 text-primary cursor-pointer" onClick={toggle}/>}

            {contract.is_active && (
                <Tooltip triggerBtn={<i className="fas fa-trash mt-1 text-muted"/>}>
                    {t('archiveContractModal.cantArchive')}
                </Tooltip>
            )}
        </React.Fragment>
    );
};

export default enhance(ContractArchiveModal);
